<template>
  <header class="flex-column justify-between align-center mb-4">
    <SmartTitle class="main-title mb-3" weight="medium">Budget Anual</SmartTitle>
    <div class="flex justify-between align-center">
      <div class="flex flex-row" style="position: relative;">
        <SmartSearch class="main-search">
          <v-text-field
            v-model="search"
            @keyup="searchBudget"
            append-icon="search"
            placeholder="Pesquisar..."
            single-line
            hide-details
            class="search"
          />
        </SmartSearch>
        <SmartButton
          :disabled="loading"
          :loading="loading"
          @click="modelDownload"
          style="width: 14rem; position: absolute; top: 0; right: 25%; background-color: #FFFFFF; color: #77BD4F; border: 1px solid #77BD4F;"
        >
          <SmartIcon name="upload" class="mr-2" :size="1"/>
          Baixar Modelo
        </SmartButton>
        <input
          v-if="resetInputFile"
          style="visibility:hidden"
          type="file"
          :key="fileUploadKey"
          id="fileInput"
          @change="fileUpload"
        />
        <label
          class="label-import cursor-pointer smart-button--default rounded h-5 text-center user-select-none"
          for="fileInput"
          style="width: 14rem; position: absolute; top: 0; right: 0; display: flex; align-items: center; padding-left: 3rem">
          <SmartIcon name="download" :size="1"/>&nbsp;&nbsp;
          Importar Arquivo
        </label>
      </div>

      <SmartModal
        v-if="modal"
        v-bind="modal"
        @close="onCloseModal">
        {{ modal.text }}
      </SmartModal>
    </div>
  </header>
</template>

<script>
// @flow
import { mapActions } from 'vuex';
import { downloadCsvFile } from 'utils/blob';

export default {
  data() {
    return {
      modal: null,
      resetInputFile: true,
      loading: false,
      fileUploadKey: 0,
      search: ''
    };
  },
  components: {
    SmartSearch: () => import('../../../../../../packages/SmartSearch/index')
  },
  methods: {
    ...mapActions({
      sendBudget: 'budget/sendBudget',
      downloadModelBudget: 'budget/downloadModelBudget',
      fetchAllBudgets: 'budget/fetchAllBudgets',
      fetchBudgetControl: 'budget/fetchBudgetControl',
      fetchDownloadReturned: 'budget/fetchDownloadReturned'
    }),

    disableKeysWithLessThanThreeCharacters(keyCode) {
      return [37, 38, 39, 40].includes(keyCode);
    },

    async searchBudget(e) {
      if (!this.search) {
        if (!this.disableKeysWithLessThanThreeCharacters(e.keyCode)) {
          await this.fetchAllBudgets();
          await this.fetchBudgetControl();
        }
      } else {
        await this.fetchAllBudgets({ page: 1, search: this.search });
        await this.fetchBudgetControl({ page: 1, search: this.search });
      }
      return null;
    },

    async modelDownload() {
      this.loading = true;
      const dataFile = await this.downloadModelBudget();
      const currentDate = 'Modelo de Budget';
      downloadCsvFile({ filename: currentDate, file: dataFile });
      this.loading = false;
    },
    fileUpload(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.set('budget', file, file.name);

      this.showLoadingModal();
      this.sendBudget(formData)
        .then(({ data }) => {
          if (!data.returned) {
            // não retornou / sucesso / arquivo válido
            this.fetchAllBudgets();
            this.fetchBudgetControl();
            this.showSuccessModalFileImport();
          } else {
            // retornou / falha / arquivo inválido
            this.fetchDownloadReturned(data);
            this.showErrorModalFileImport();
          }
        })
        .catch(async ({ data }) => {
          this.resetInputFile = false;
          this.showGenericErrorModalFileImport(data);
          await this.$nextTick();
          this.resetInputFile = true;
        });
    },
    showGenericErrorModalFileImport() {
      this.modal = {
        type: 'warning',
        title: 'Ops! Algo deu errado!',
        icon: 'alert',
        buttonText: 'Ok, vou tentar novamente.',
        text: 'Falha ao importar o arquivo'
      };
    },
    showErrorModalFileImport() {
      this.modal = {
        type: 'warning',
        title: 'Ops! Algo deu errado!',
        icon: 'alert',
        buttonText: 'Ok, vou corrigir e tentar novamente.',
        text: 'O arquivo enviado não pôde ser aceito pois contém informações inválidas.'
      };
    },
    showSuccessModalFileImport() {
      this.modal = {
        type: 'success',
        title: 'Tudo Certo!',
        icon: 'accepted',
        buttonText: 'Ok',
        text: 'Arquivo importado com sucesso.'
      };
    },
    showLoadingModal() {
      this.modal = {
        type: 'default',
        title: 'Carregando Arquivo...',
        icon: 'union',
        text: 'Estamos subindo o arquivo, aguarde um instante...'
      };
    },
    onCloseModal() {
      this.modal = null;
      this.fileUploadKey++;
    }
  }
};
</script>

<style lang="scss">
.label-import {
  font-size: 14px;
  transition: background-color $transition-sm-medium $transition-easing-default;
  p {
    margin-top: 10px;
  }
  &:hover {
    background-color: lighten($color-brand-secondary, 10);
  }
  &:active {
    background-color: darken($color-brand-secondary, 10);
  }
}

</style>
